<template>
  <div id="document">
    <Header></Header>
    <Navi currentPage="online" :naviHeight="naviH"></Navi>
    <div class="main_doc" id="main">
        <Submit v-if="!server_down"></Submit>
        <div class="announcement"  v-if="server_down">
            The server of the online tool is being upgraded and is expected to return to normal at 00:00 on March 2 (GMT+8).
        </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import Doc from '@/components/doc.vue'
import Submit from '@/components/submit.vue'
import UpdateImg from '@/assets/img/update.png'

import {api_dir} from '@/bus.js'
import axios from 'axios/dist/axios.min';

// import EleDoc from '@/components/eledoc.vue'
export default {
    name: 'online',
    components: {Navi,Footer,Doc,Header,Submit},
    data:function(){
        return {
            // download_head:['Type','File','Description','Size','Version'],
            // download_records:[
            //     ['KGGSEE java package','<a style="color:#006652;" href="https://mailsysueducn-my.sharepoint.com/:u:/g/personal/limiaoxin_mail_sysu_edu_cn/EUzkxhKOcAJLlzuQdd7AfZEB1m8Jqf_xyksvf2CuMjrJtw?e=2FCQQ2">kggsee.jar</a>',
            //     'this is java package of KGGSEE, without resources','27.4MB','1.0'],
            //     ['Resources','<a style="color:#006652;" href="https://mailsysueducn-my.sharepoint.com/:f:/g/personal/limiaoxin_mail_sysu_edu_cn/EoQhliz7Jv5KmpxllMJ0N0gBizeGDNec8QGEVheRkuMGdQ?e=gI3oSh">resources/</a>',
            //     '','','1.0'],
            //     ['Examples Data','<a style="color:#006652;" href="static/resources/gwas_summary.txt.gz">examples/</a>',
            //     '','','1.0'],
            // ],
            updates:[],
            updateImg:UpdateImg,
            naviH:'',
            server_down:false,
        }
    },
    watch:{
        updates:function(){
             var _this = this;
            _this.$nextTick(function () {
                _this.getHeigth()
            });
        }
    },
    mounted () {
        this.getHeigth()
    },
    methods:{
        getHeigth(){
            var h = document.getElementById('main').clientHeight;
            console.log(h)
            // if (h<400){
            //     h=400
            // }
            this.naviH=h+'px'
        }
    }

}
</script>

<style scoped>
.main_doc{
    width: 960px;
    border: solid #E1EAEA 1px;
    position: relative;
  top:85px;
  bottom: 10px;
  left: 205px;
  /* height: 600px; */
  margin-left: 15px;
  margin-top: 10px;
  padding-bottom: 10px;
  min-height: 400px;
}
.cont{
    margin-left: 30px;
	vertical-align: middle;
}

p {
    color: #000000;
    line-height: 15px;
    font-size: 15px;
    margin:5px 0px;
}

h2{
    font-size: 20px;
    line-height: 20px;
    margin:15px 0px;
}

a{
    color:#006652;
}

.download_table{
    width: 850px;
    margin: 10px ;
}
.update_ico{
    height: 18px;
    float: left;
    margin-right: 5px;
    margin-top: 1px;
}

.update_content,.update_title{
    width: 800px;
}

.update_title {
    /* background: #E0E7D8; */
    /* height: 28px; */
}
.update_title p{
    font-weight: bold;
    background: #E0E7D8;
    font-size: 16px;
    line-height: 19px;
}

.update_content p{
    margin-left: 25px;
}

.announcement{
    margin: 30px;
    padding: 10px;
    font-weight: bold;
    background: #E0E7D8;
    font-size: 24px;
    line-height: 34px;
}

</style>


// WEBPACK FOOTER //
// src/views/online.vue